import { render, staticRenderFns } from "./InputAutosuggest.desktop.vue?vue&type=template&id=b7893ba8&scoped=true&"
import script from "./InputAutosuggest.desktop.vue?vue&type=script&lang=js&"
export * from "./InputAutosuggest.desktop.vue?vue&type=script&lang=js&"
import style0 from "./InputAutosuggest.desktop.vue?vue&type=style&index=0&id=b7893ba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7893ba8",
  null
  
)

export default component.exports